var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapPinCircleStroke({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35 64C36.6569 64 38 65.3431 38 67C38 68.6569 36.6569 70 35 70C33.3431 70 32 68.6569 32 67C32 65.3431 33.3431 64 35 64ZM35 66C34.4477 66 34 66.4477 34 67C34 67.5523 34.4477 68 35 68C35.5523 68 36 67.5523 36 67C36 66.4477 35.5523 66 35 66Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35 2C49.9117 2.00001 62 14.2724 62 29C62 40.0493 55.1958 49.5292 45.5 53.5752C40.4879 55.6667 38.75 56.4444 37.25 59.4072C37.1039 59.6957 36.9791 59.9706 36.8633 60.2256C36.3843 61.2796 36.0568 62 35 62C33.9432 62 33.6157 61.2796 33.1367 60.2256C33.0209 59.9706 32.8961 59.6957 32.75 59.4072C31.25 56.4444 29.3749 55.6667 24.5 53.5752C14.8042 49.5292 8 40.0493 8 29C8 14.2724 20.0883 2 35 2ZM35 5C21.7452 5 11 15.7452 11 29C11 42.2548 21.7452 53 35 53C48.2548 53 59 42.2548 59 29C59 15.7452 48.2548 5 35 5Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPinCircleStroke);
export default __webpack_public_path__ + "static/media/map_pin_circle_stroke.4f5f5ed63d54d3e071f1830f2167a828.svg";
export { ForwardRef as ReactComponent };